export function parseApiErrorBody(body: unknown): string | null {
    if (typeof body === 'string') {
        const trimmed = body.trim();
        return trimmed.length > 0 ? trimmed : null;
    }

    if (!body || typeof body !== 'object') {
        return null;
    }

    const record = body as Record<string, unknown>;
    for (const key of ['error', 'message', 'details'] as const) {
        const value = record[key];
        if (typeof value === 'string' && value.trim()) {
            return value.trim();
        }
    }

    return null;
}

export async function readApiErrorFromResponse(response: Response): Promise<string> {
    const fallback = `Request failed: ${response.statusText || String(response.status)}`;

    try {
        const contentType = response.headers.get('Content-Type') ?? '';
        if (contentType.includes('application/json')) {
            const body: unknown = await response.json();
            return parseApiErrorBody(body) ?? fallback;
        }

        const text = await response.text();
        return parseApiErrorBody(text) ?? (text.trim() || fallback);
    } catch {
        return fallback;
    }
}

export function getMutationErrorMessage(err: unknown, fallback: string): string {
    if (err instanceof Error && err.message.trim()) {
        return err.message.trim();
    }

    return fallback;
}
